export const FETCH_USER_LIST = 'FETCH_USER_LIST';
export const FETCH_USER_LIST_SUCCESS = 'FETCH_USER_LIST_SUCCESS';
export const FETCH_USER_LIST_FAILURE = 'FETCH_USER_LIST_FAILURE';
export const RELOAD_USER_LIST = 'RELOAD_USER_LIST';
export const RESET_USER_ITEMS = 'RESET_USER_ITEMS';